export default __webpack_public_path__ + "static/media/ps_02.4caf28e1.png";